import { Clock } from "lucide-react";
import { useLocalizedField } from '@/hooks/useLocalizedField';
import { useTranslations, useLocale } from 'next-intl';

export default function RestaurantCard({ item, isActive }: any) {
  const { getLocalizedField } = useLocalizedField();
  const t = useTranslations();
  const locale = useLocale();
  
  if (!item)
    return (
      <div className="animate-pulse">
        <div className="relative h-96 rounded-2xl overflow-hidden bg-gray-300">
          <div className="w-full h-full bg-gray-300"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 space-y-3">
            <div className="h-4 bg-gray-400 rounded w-3/4"></div>
            <div className="h-3 bg-gray-400 rounded w-1/4"></div>
            <div className="h-3 bg-gray-400 rounded w-1/2"></div>
            <div className="h-3 bg-gray-400 rounded w-2/3"></div>
          </div>
        </div>
      </div>
    );

  const getDayNames = () => {
    switch (locale) {
      case 'ar':
        return ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
      case 'fr':
        return ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
      default:
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    }
  };
  
  const dayNames = getDayNames();
  const today = dayNames[new Date().getDay()];
  const todayOpening = item.opening_hours?.[today] || t('restaurants.notAvailable');

  return (
    <a
       href={`/restaurants/${item.slug}`}
      className={`cursor-pointer transition-all duration-500 ${
        isActive ? "scale-110 z-20" : "scale-90 "
      }`}
    >
      <div className="relative h-96 rounded-2xl overflow-hidden">
        {/* IMAGE */}
        <img
          src={item.images?.[2]}
          alt={getLocalizedField(item, 'name')}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />

        {/* GRADIENT */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />

        {/* CONTENT */}
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white space-y-3">
          {/* NAME + ADDRESS */}
          <h3 className="text-xl font-semibold truncate">{getLocalizedField(item, 'name')}</h3>
          <p className="text-sm text-gray-300 line-clamp-2">{getLocalizedField(item, 'address')}</p>

          {/* OPENING HOURS */}
          <div className="flex items-center gap-2 text-sm text-gray-300">
            <Clock className="h-4 w-4 text-white" />
            <span>{todayOpening}</span>
          </div>
        </div>
      </div>
    </a>
  );
}
